<template>
  <div class="item-box-content" style="padding:15px;height:400px;">
    <el-row>
      <el-col
        :xl="6"
        :lg="8"
        :md="12"
        style="padding:15px 15px;"
      >
        <el-card shadow="hover" :body-style="{ padding: '0px' }" class="related-accessory-card">
          <div>合同编号：{{dataList.pcbNumber}}</div>
          <div style="padding:35px 0;">
          </div>
          <div>
            <el-button type="primary" @click="sourceFileDown" plain>下载</el-button>
          </div>
        </el-card>
      </el-col>
        <el-col
        :xl="6"
        :lg="8"
        :md="12"
        style="padding:15px 15px;"
      >
        <el-card shadow="hover" :body-style="{ padding: '0px' }" class="related-accessory-card">
          <div>盖章上传合同：{{dataList.pcbNumber}}</div>
          <div style="padding:35px 0;">
          </div>
          <div>
            <el-button type="primary" @click="stampFileFileDown" plain>下载</el-button>
          </div>
        </el-card>
      </el-col>

    </el-row>
  </div>
</template>
<script>
import { queryContract } from '@/api/purchase/purchaseManage'
import { uploadDown } from '@/util/tool'

export default {

  data () {
    return {
      dataList: [],
      currentDate: new Date(),
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  mounted () {

  },
  methods: {
    getList () {
      queryContract(this.$route.query.pcbId, 2).then((res) => {
        if (res.data.code === 200) {
          this.dataList = res.data.obj
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 合同下载
    sourceFileDown () {
      uploadDown(
        this.$store.state.https + this.dataList.sourceFile,
        '采购合同：' + this.dataList.pcbNumber
      )
    },
    stampFileFileDown () {
      uploadDown(
        this.$store.state.https + this.dataList.stampFile,
        '盖章上传合同：' + this.dataList.pcbNumber
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.related-accessory-card {
  height: 208px;
  border-radius: 4px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    text-align: center;
  }
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}
</style>
